<template>
    <router-view></router-view>
</template>

<script>
export default {
    created(){
         this.$store.dispatch("Layouts/set_layout", 'accountants-layout');
    }
}
</script>